import { createApi } from "@reduxjs/toolkit/query/react";

import { encryptionOnlyBaseQuery } from "../../utils/authentication/fetchBaseQuery";
import {
  transformErrorResponse,
  transformSuccessResponse
} from "../../utils/middleware/responseMiddleware2";

export const candidateFormApi = createApi({
  reducerPath: "candidateFormApi",
  baseQuery: encryptionOnlyBaseQuery,
  tagTypes: ["FormLanding", "FormFilling"],
  endpoints: (builder) => ({
    getCandidateFormLandingInformation: builder.query({
      query: (token) => ({
        url: "/CandidateFormAccess/GetLandingInformation",
        method: "GET",
        params: { token }
      }),
      providesTags: (_result, _error, token) => [{ type: "FormLanding", id: token }],
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    getCandidateFormForFilling: builder.query({
      query: (token) => ({
        url: "/CandidateFormAccess/GetFormForFilling",
        method: "GET",
        params: { token }
      }),
      providesTags: (_result, _error, token) => [{ type: "FormFilling", id: token }],
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    saveCandidateFormDraft: builder.mutation({
      query: (data) => ({
        url: "/CandidateFormAccess/SaveDraft",
        method: "POST",
        body: data
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    submitCandidateForm: builder.mutation({
      query: (data) => ({
        url: "/CandidateFormAccess/SubmitForm",
        method: "POST",
        body: data
      }),
      invalidatesTags: (_result, _error, data) => [
        { type: "FormLanding", id: data.token },
        { type: "FormFilling", id: data.token }
      ],
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    })
  })
});

export const {
  useGetCandidateFormLandingInformationQuery,
  useGetCandidateFormForFillingQuery,
  useSaveCandidateFormDraftMutation,
  useSubmitCandidateFormMutation
} = candidateFormApi;
